preApproval = {
    bind : function() {

        preApproval.updateStatus();
    },
    hasFields : function() {
        if(!repaymentTermCalculator.amount()) {
            return false;
        }

        if(!pay.monthlySurplus()) {
            return false;
        }

        return true;
    },
    updateStatus: function() {
        if(!preApproval.hasFields()) {
            preApproval.tickColor('#e0eaf4');
            preApproval.message('Unknown');
            preApproval.toggleDescription('unknown');
            return;
        }

        let totalSurplus = pay.monthlySurplus() - repaymentTermCalculator.monthlyAmount();
        if(totalSurplus > 1200 ) {
            preApproval.tickColor('#23C272');
            preApproval.message('Likely');
            preApproval.toggleDescription('likely');
        } else {
            preApproval.tickColor('#c2a583');
            preApproval.message('Pending');
            preApproval.toggleDescription('pending');
        }
    },
    tickColor : function(color) {
        jQuery('.pre-approval-tick').css('background-color', color);
    },
    message : function(message) {
        jQuery('.pre-approval-message').text(message);
    },
    toggleDescription : function (type) {
        jQuery('.pre-approval-description').addClass('d-none');
        jQuery('.pre-approval-description__' + type).removeClass('d-none');
    }

};

pay = {
    frequency : function() {
        let selectedFrequency = jQuery('input[name=PayFrequency]:checked,input[name=FrequencyOfPayments]:checked');
        return selectedFrequency.length ? selectedFrequency.val() : '';
    },
    monthlySurplus : function() {
        let surplus = currencyHelpers.fromElement( jQuery('input[name=PayAmountAfterBills]'));
        return weekFortnightMonths[pay.frequency()] * surplus;
    },
    toggleFields : function () {
        let selectedFrequency = jQuery('input[name=PayFrequency]:checked,input[name=FrequencyOfPayments]:checked');
        if(selectedFrequency.length) {
            jQuery('.show-on-frequency').removeClass('d-none');
            jQuery('.pay-amount-title').text(
                jQuery('.pay-amount-title').data('title').replace('%s', selectedFrequency.val())
            );
        }
    }
}


repaymentTermCalculator = {
    frequency : function() {
        return pay.frequency();
    },
    length : function() {
        return parseInt( jQuery('.repayment-holder').find('input[name=RepaymentTermInMonths]').val() ) || 0
    },
    payments : function() {
        return Math.ceil(repaymentTermCalculator.length() * weekFortnightMonths[repaymentTermCalculator.frequency()]);
    },
    monthlyAmount : function() {
        if(!pay.frequency()) {
            return 0;
        }

        let loanAmount = loanTotals.total();

        if(loanAmount <= 0) {
            return 0;
        }

        return monthlyPaymentsCalculator(loanAmount, repaymentTermCalculator.length()).toFixed(2);
    },
    amount : function() {
        let paymentFrequency = repaymentTermCalculator.frequency(),
            monthlyAmount = repaymentTermCalculator.monthlyAmount();

        if(monthlyAmount <= 0) {
            return 0;
        }

        return (parseFloat(monthlyAmount) / weekFortnightMonths[paymentFrequency]).toFixed(2);
    },
    calculatePayments: function() {
        let repaymentHolder = jQuery('.repayment-holder'),
            amount = repaymentTermCalculator.amount(),
            frequency = repaymentTermCalculator.frequency();

        jQuery('.have-payment-info').addClass('d-none');

        if(repaymentHolder.length === 0) {
            return false;
        }

        if(amount === 0) {
            return false;
        }

        jQuery('.have-payment-info').removeClass('d-none');

        let displayText = repaymentTermCalculator.payments().toString() +
            ' ' +
            frequency +
            ' payments of $' +
            amount;

        if(frequency !== 'monthly') {
            displayText = displayText +
                ' over ' +
                repaymentTermCalculator.length().toString() +
                ' months';
        }

        jQuery('.repayment-details').text(displayText);

        jQuery('input[name=Repayments]').val( amount );

        preApproval.updateStatus();
    }
};

jQuery( document ).ready(function() {
    jQuery('input[name=PayFrequency],input[name=FrequencyOfPayments]').on('click change', function() {
        pay.toggleFields();
        repaymentTermCalculator.calculatePayments();
    });
    pay.toggleFields();

    jQuery('input[name=PayAmountAfterBills]').on('change keyup', function() {
        preApproval.updateStatus();
    });

    jQuery('input[name=RepaymentTermInMonths]').on('change input', repaymentTermCalculator.calculatePayments);

    repaymentTermCalculator.calculatePayments();
});



